// Strips accents for a sort/search comparison so it matches how a French
// speaker expects e.g. "Édibilité" to sort next to "Détermination" rather
// than after "Zzz" - shared by GlossaryPage.js and LinksPage.js.
export default function normalize(text) {
  return text.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
}
flarum.reg.add('champis-others', 'forum/utils/normalize', normalize);